// extracted by mini-css-extract-plugin
export default {"commentLengthTextInput":"CommentLengthConfig-commentLengthTextInput-b4dfa14910d687d339f5a941d97b7141","annotation":"CommentLengthConfig-annotation-1cc5e675656a23c7809465d0f93eeb7b"};